import {
  stringNumberSchema,
  nullableStringNumberSchema,
} from 'common/validationSchemas/stringNumberSchema';
import * as yup from 'yup';
import { getRequiredErrorMessage } from 'common/utils/validation';

export const cacheValidationSchema: yup.AnyObjectSchema = yup.object().shape({
  tendered: stringNumberSchema.required(getRequiredErrorMessage),
  onAccount: nullableStringNumberSchema,
});
